import {appRouter, mainRouter} from '@/plugins/router/router';
import Vue from 'vue';
import store from "../index";


const app = {
    // namespaced:true,
    state: {
        isCallHelp:false, // 求救视频是否开启了
        isOpenDownload:false, // 是否开启下载
        community: {},
        lift_state_param_settings:null, // 电梯状态参数设置
        isFullScreen: false,
        openedSubmenuArr: [], // 要展_开的菜单数组
        menuTheme: 'dark', // 主题
        themeColor: '',
        pageOpenedList: [],
        isMobile:false,
        currentPageName: '',
        currentPath: [
            {
                title: '电梯云官网',
                path: '/index-product',
                name: 'index-product'
            }
        ], // 面包屑数组
        menuList: [],//菜单选项
        resourceNames: [],
        communityResourceNames: [],
        routers: [
            ...appRouter, mainRouter
        ],
        tagsList: [],
        messageCount: 0,
        dontCache: ['text-editor', 'artical-publish'], // 在这里定义你不想要缓存的页面的name属性值(参见路由配置router.js)
        updateDeviceList:[],
        showContentMenu: false,
        departTree: []
    },
    mutations: {
        callHelp(state,data){
            state.isCallHelp=data;
        },
        setLiftStateParams(state,data){
            state.lift_state_param_settings = data
        },
        update_lift_state_params(state,data){
            state.lift_state_param_settings = data
        },
        //改变下载状态
        changeDownloadState(state,data){
            state.isOpenDownload = data
        },
        addBatchDevice(state,data) {
            let updateDevice=localStorage.getItem("updateDeviceList");
            if(updateDevice==null){
                state.updateDeviceList.push(data);
                localStorage.updateDeviceList=JSON.stringify(state.updateDeviceList);
            }else{
                let flag=true;
                state.updateDeviceList.forEach(item=>{
                    if(item.id==data.id){
                        flag=false;
                    }
                });
                if(flag){
                    state.updateDeviceList.push(data);
                    localStorage.updateDeviceList=JSON.stringify(state.updateDeviceList)
                }
            }
        },
        delBatchDevice(state,data){
            state.updateDeviceList.forEach((item,index)=>{
                if(item.id==data.id){
                    state.updateDeviceList.splice(index,1);
                }
            });
            localStorage.updateDeviceList=JSON.stringify(state.updateDeviceList)
        },
        clearBatchDevice(state){
            state.updateDeviceList=[];
            localStorage.removeItem("updateDeviceList");
        },
        setUpdateDeviceList (state) {
            state.updateDeviceList =localStorage.updateDeviceList? JSON.parse(localStorage.updateDeviceList):[];
        },
        setHeadURL (state, url) {
            state.admin.head_url = url;
        },
        setTagsList (state, list) {
            state.tagsList.push(...list);
        },
        setMenuList (state, op) {//设置菜单  出现哪些菜单
            if (store.state.user.isROOT) {// 如果是最高权限给所有
                state.menuList = appRouter;
                return;
            }
            let menuList = []; // 看这个人能看到多少个菜单
            appRouter.forEach((item, index) => {
                if (store.state.user.resKeys.has(item.name)) {
                    menuList.push(item);
                        let childrenArr = [];
                    // if (item.children.length === 1) {
                    //     if (store.state.user.resKeys.has(item.children[0].name)) menuList.push(item.children[0]);
                    // } else {
                    // let len = menuList.push(item);
                    item.children.forEach((child) => {
                            if (store.state.user.resKeys.has(child.name)) {
                                childrenArr.push(child);
                            }
                        });
                        if (childrenArr.length){ // 存在子页面
                            item.children = childrenArr;
                        } else {
                            menuList.pop();//删除并返回数组中的最后一个元素
                        }
                    // }
                }
            });
            state.menuList = menuList;
        },


        // updateMenulist (state) {
        //     let accessCode = parseInt(Cookies.get('access'));
        //     let menuList = [];
        //     appRouter.forEach((item, index) => {
        //         //TODO 设置menulist
        //         if (item.access !== undefined) {
        //             if (Util.showThisRoute(item.access, accessCode)) {
        //                 if (item.children.length === 1) {
        //                     menuList.push(item);
        //                 } else {
        //                     let len = menuList.push(item);
        //                     let childrenArr = [];
        //                     childrenArr = item.children.filter(child => {
        //                         if (child.access !== undefined) {
        //                             if (child.access === accessCode) {
        //                                 return child;
        //                             }
        //                         } else {
        //                             return child;
        //                         }
        //                     });
        //                     menuList[len - 1].children = childrenArr;
        //                 }
        //             }
        //         } else {
        //             if (item.children.length === 1) {
        //                 menuList.push(item);
        //             } else {
        //                 let len = menuList.push(item);
        //                 let childrenArr = [];
        //                 childrenArr = item.children.filter(child => {
        //                     if (child.access !== undefined) {
        //                         if (Util.showThisRoute(child.access, accessCode)) {
        //                             return child;
        //                         }
        //                     } else {
        //                         return child;
        //                     }
        //                 });
        //                 if (childrenArr === undefined || childrenArr.length === 0) {
        //                     menuList.splice(len - 1, 1);
        //                 } else {
        //                     let handledItem = JSON.parse(JSON.stringify(menuList[len - 1]));
        //                     handledItem.children = childrenArr;
        //                     menuList.splice(len - 1, 1, handledItem);
        //                 }
        //             }
        //         }
        //     });
        //     state.menuList = menuList;
        // },
        changeMenuTheme (state, theme) {
            state.menuTheme = theme;
        },
        changeMainTheme (state, mainTheme) {
            state.themeColor = mainTheme;
        },
        addOpenSubmenu (state, name) {
            let hasThisName = false;
            let isEmpty = false;
            if (name.length === 0) {
                isEmpty = true;
            }
            if (state.openedSubmenuArr.indexOf(name) > -1) {
                hasThisName = true;
            }
            if (!hasThisName && !isEmpty) {
                state.openedSubmenuArr.push(name);
            }
        },
        closePage (state, name) {
            state.cachePage.forEach((item, index) => {
                if (item === name) {
                    state.cachePage.splice(index, 1);
                }
            });
        },
        initCachepage (state) {
            if (localStorage.cachePage) {
                state.cachePage = JSON.parse(localStorage.cachePage);
            }
        },
        //添加面包屑
        // addPageList(state,item){
        //     //配置每个面包屑
        //     if (state.pageOpenedList.length>0&&item.title==state.pageOpenedList[0].title){
        //         if(item.nvaItem==state.pageOpenedList[1].title){
        //         }else{
        //             let childPage = {}
        //             childPage.title=item.nvaItem
        //             state.pageOpenedList.splice(1,1,childPage)
        //         }
        //     }else{
        //         let page={}
        //         page.title=item.title
        //         let childPage = {}
        //         childPage.title=item.nvaItem
        //         state.pageOpenedList.splice(0,1,page)
        //         state.pageOpenedList.splice(1,1,childPage)
        //     }
        // },
        //点击首页，清除
        clearPageList(state){
            state.pageOpenedList=[];
        },
        //点击关闭，移除该面包屑
        removeTag (state, name) {
            state.pageOpenedList.map((item, index) => {
                if (item.name === name) {
                    state.pageOpenedList.splice(index, 1);
                }
            });
        },
        //**********************************************************************
        // pageOpenedList (state, item) {
        //     var pageJson={}
        //     pageJson.name=item.name
        //     pageJson.title=item.title
        //     pageJson.path=item.name
        //     state.pageOpenedList.push(pageJson)
        //     // let openedPage = state.pageOpenedList[get.index];
        //     // if (get.argu) {
        //     //     openedPage.argu = get.argu;
        //     // }
        //     // if (get.query) {
        //     //     openedPage.query = get.query;
        //     // }
        //     // state.pageOpenedList.splice(get.index, 1, openedPage);
        //     // localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        //
        // },
        // clearAllTags (state) {
        //     state.pageOpenedList.splice(1);
        //     state.cachePage.length = 0;
        //     localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        // },
        // clearOtherTags (state, vm) {
        //     let currentName = vm.$route.name;
        //     let currentIndex = 0;
        //     state.pageOpenedList.forEach((item, index) => {
        //         if (item.name === currentName) {
        //             currentIndex = index;
        //         }
        //     });
        //     if (currentIndex === 0) {
        //         state.pageOpenedList.splice(1);
        //     } else {
        //         state.pageOpenedList.splice(currentIndex + 1);
        //         state.pageOpenedList.splice(1, currentIndex - 1);
        //     }
        //     let newCachepage = state.cachePage.filter(item => {
        //         return item === currentName;
        //     });
        //     state.cachePage = newCachepage;
        //     localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        // },
        // setOpenedList (state) {
        //     state.pageOpenedList = localStorage.pageOpenedList ? JSON.parse(localStorage.pageOpenedList) : [otherRouter.children[0]];
        // },
        setCurrentPath (state, pathArr) {
            state.currentPath = pathArr;
        },
        //设置首页路由
        setIndexCurrentPath(state, pathArr){
            state.currentPath = pathArr;
        },
        setCurrentPageName (state, name) {
            state.currentPageName = name;
        },
        setAvator (state, path) {
            localStorage.avatorImgPath = path;
        },
        switchLang (state, lang) {
            state.lang = lang;
            Vue.config.lang = lang;
        },
        clearOpenedSubmenu (state) {
            state.openedSubmenuArr.length = 0;
        },
        setMessageCount (state, count) {
            state.messageCount = count;
        },
        // increateTag (state, tagObj) {
        //     if (!Util.oneOf(tagObj.name, state.dontCache)) {
        //         state.cachePage.push(tagObj.name);
        //         localStorage.cachePage = JSON.stringify(state.cachePage);
        //     }
        //     state.pageOpenedList.push(tagObj);
        //     localStorage.pageOpenedList = JSON.stringify(state.pageOpenedList);
        // },
        toggleRightBar (state,status) {
            if(status==undefined){
                state.showRightBar = !state.showRightBar;
            }else{
                state.showRightBar = status;
            }
        },
        updateMonitorWindowToAdmin(state, windows) {
            let commId = state.admin.community_id;
            state.admin.monitor_windows['comm_'+commId] = windows['comm_'+commId];
        },
        replaceLiftToWindow (state, op) {
            let commId = state.admin.community_id;
            state.admin.monitor_windows['comm_'+commId][op.win].win_lifts.splice(op.position, 1, op.lift);
        },
        clearAuth(state) {

        },
        showMenu (state) {
            state.showContentMenu = true;
            setTimeout(() => {
                document.addEventListener('click', (e) => {
                    state.showContentMenu = false;
                }, {once: true})
            }, 300)
        },
        setDepartTree(state, tree) {
            state.departTree = tree;
        },
        setMobile(state, isMobile){
            state.isMobile = isMobile;
        }
    }
};

export default app;
